// src/data/analysis.ts
import { request } from '../utils/request';
const { REACT_APP_BACKEND } = process.env;

export const sendFiles = async (formData: FormData) => {
    try {
        // clear local storage where id is chatHistory or chatFlowId
        console.log('Clearing local storage for chat input history and flow ID');
        localStorage.removeItem('chatInputHistory');
        localStorage.removeItem('c63209b9-9a5d-4873-a9a1-b345138660a9_EXTERNAL');
        
        // Start task and get task ID
        const response = await request('/analysis/project-analysis/start', {
            method: 'POST',
            data: formData,
            credentials: 'include'
        });
        return response.task_id;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

// New function to get task status
export const getTaskStatus = async (taskId: string) => {
    try {
        const response = await request(`/analysis/project-analysis/status/${taskId}`, {
            method: 'GET',
            credentials: 'include'
        });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

// New function to create event source for streaming updates
export const createTaskEventSource = (taskId: string) => {
    return new EventSource(`${REACT_APP_BACKEND}/analysis/project-analysis/stream/${taskId}`, {
        withCredentials: true
    }
)};      

export const sendCompanyRequest = async (analysisText: string) => {
    try {
        const response = await request('/analysis/match-companies', {
            method: 'POST',
            data: { analysis_text: analysisText },
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const sendCandidateRequest = async (requestPayload: any) => {
    try {
        const response = await request('/analysis/match-candidates', {
            method: 'POST',
            data: requestPayload,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
        });
        console.log(response)
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const analyseForCV = async (taskId: string, userPrompt?: string) => {
    localStorage.removeItem('chatInputHistory');
    localStorage.removeItem('c63209b9-9a5d-4873-a9a1-b345138660a9_EXTERNAL');

    try {
        const requestPayload = {
            task_id: taskId,
            user_prompt: userPrompt ? userPrompt : null
        };
        const response = await request('/analysis/reanalyze-for-cv', {
            method: 'POST',
            data: requestPayload,
            credentials: 'include'
        });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const getSignedCvUrl = async (employeeId: string, s3Key: string): Promise<string> => {
    const response = await request<{ url: string }>('/employee/s3_download', {
        method: 'GET',
        params: {
            employee_id: employeeId,
            s3_key: s3Key,
        },
    });
    return response.url;
  };